import { Spin } from 'antd';

import useAPIQuery from '../api/useAPIQuery';
import styles from './AppLoading.module.css';

const AppLoading: React.FC = ({ children }) => {
  const hello = useAPIQuery(['/hello/'], {
    keepPreviousData: true,
    retry: false,
  });

  if (hello.isSuccess) {
    return <>{children}</>;
  }

  return (
    <Spin data-testid="AppLoading" className={styles.spin} delay={300} spinning={hello.isLoading} />
  );
};

export default AppLoading;
